// extracted by mini-css-extract-plugin
export default {"v2Container":"v2Container--OOGWn","selfAdaption":"selfAdaption--qyFdT"};